module.exports = __webpack_public_path__ + "img/credit-card.f9687e0b.svg";